import { render } from "./about-section.vue?vue&type=template&id=31bea550"
import script from "./about-section.vue?vue&type=script&lang=js"
export * from "./about-section.vue?vue&type=script&lang=js"

import "./about-section.vue?vue&type=style&index=0&id=31bea550&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__